import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast"
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
            position="top-right"
            toastOptions={{ className: "react-hot-toast" }}
          />
    </BrowserRouter>
  </React.StrictMode>
);
